var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.557,
    height: 15.557,
    viewBox: "0 0 15.557 15.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-width:3px}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_372",
    "data-name": "Group 372",
    transform: "rotate(-45 7.621 8.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_102",
    d: "M0 0v16",
    className: "prefix__cls-1",
    "data-name": "Path 102",
    transform: "translate(8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_103",
    d: "M0 0v16",
    className: "prefix__cls-1",
    "data-name": "Path 103",
    transform: "rotate(-90 4 4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.b096626cc64448c10c6b0327e8cd0678.svg";
export { ForwardRef as ReactComponent };